export default {"src":"/_next/static/media/source-listing.9342ccb9.svg","height":460,"width":1041,"blurWidth":0,"blurHeight":0};